import powerpoint from './powerpoint/index.js'
import excel from './excel/index.js'

export default {
  powerpoint,
  excel,
}
